function Headers({ headers }) {
  return (
    <thead>
      <tr>
        {headers.map((header) => (
          <th scope="col" className={header.className}>
            {header.content}
          </th>
        ))}
      </tr>
    </thead>
  );
}
export default Headers;
